import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { patchesActionTypes } from '../reducer';

function* fetchPatch() {
  yield requestSaga({
    actionType: patchesActionTypes.getOne,
    request: dataProvider.getOne,
    resource: resources.patch.index,
  });
}

export default fetchPatch;
